import styled from 'styled-components';

interface StyleProps {}

export const VMSAccountContainer = styled.div<StyleProps>`
  width: 100%;
  margin: 0 auto;
  position: relative;
  display: flex;

  @media (max-width: 1160px) {
    display: flex;
    align-items: flex-start;
  }

  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }
`;
